import { render } from "./fopInfo.vue?vue&type=template&id=6ccd12e7"
import script from "./fopInfo.vue?vue&type=script&lang=js"
export * from "./fopInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__